<app-loader [isLoading]="isLoading"></app-loader>
@if(isUuid){
<router-outlet></router-outlet>
}@else {

<div class="header">
    <app-title [title]="title" [subtitle]="subtitle"></app-title>
    @if (myroles.can_write) {
    <div class="top">
        <div class="boton">
            <button class="b1" mat-button (click)="addPolicy()">Añadir políticas</button>
        </div>
    </div>
    }
</div>

<div class="content">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
        class="mat-elevation-z8 table">

        <!-- Columna de Título -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
                NOMBRE
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;">{{element.name}}</span>
            </td>
        </ng-container>

        <!-- Columna de Descripción -->
        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>
                DESCRIPCIÓN
            </th>
            <td mat-cell *matCellDef=" let element">
                <span style="font-size: 16px;" [innerHTML]="sanitizeHtml(element.description)"></span>
            </td>
        </ng-container>

        <!-- Columna de Acciones -->
        <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let element">
                <!-- <button mat-icon-button class="acciones"><mat-icon style="color: #2D3872;">info_outline</mat-icon></button> -->
                @if (myroles.can_write) {
                <button mat-icon-button class="acciones" (click)="goToRole(element.id)"><mat-icon
                        svgIcon="edit"></mat-icon></button>}
                @if (myroles.can_delete) {
                <button mat-icon-button class="acciones" (click)="deleteSelected(element.id, element.title)"><mat-icon
                        svgIcon="delete"></mat-icon></button>}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>
</div>
}